import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { CssBaseline } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import HeaderBar from '../HeaderBar/HeaderBar';
import Copyright from '../Copyright/Copyright';
import SessionTimeoutAlert from '../SessionTimeoutAlert/SessionTimeoutAlert';


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
    },
    main: {
        flexGrow: 1,
        alignItems: 'center',
        justifyContent: 'center',
    }
}));

const Layout = ({ children, host }) => {
    const classes = useStyles();
    const [showTimer, setShowTimer] = useState(false);
    const [secondsLeft, setSecondsLeft] = useState(60);
    const [tokenUpdatedAt, setTokenUpdatedAt] = useState(Date.now());
    const [Jwttoken, setToken] = useState(() => {
        try {
            const saved = localStorage.getItem('auth');
            return saved ? JSON.parse(saved) : null;
        } catch (error) {
            console.error('Invalid token in localStorage:', error);
            return null;
        }
    });



    useEffect(() => {

        if (!Jwttoken?.token) return;

        const token = JSON.parse(localStorage.getItem('auth'));
        if (token?.expiresAt) {
            const issuedAt = tokenUpdatedAt;
            const expireAt = issuedAt + token.expiresAt * 60 * 1000;
            const triggerAt = expireAt - 60 * 1000;
            const delayUntilCountdown = triggerAt - Date.now();

            let intervalId;
            let timeoutId;

            //If token already expired, don’t show overlay
            if (Date.now() >= expireAt) {
                console.warn("Token already expired. Skipping countdown.");
                return;
            }

            //Token still has >1 min, set timer to show overlay later
            if (delayUntilCountdown > 0) {
                timeoutId = setTimeout(() => {
                    let seconds = 60;
                    setSecondsLeft(seconds);
                    setShowTimer(true);

                    intervalId = setInterval(() => {
                        seconds -= 1;
                        setSecondsLeft(seconds);
                        if (seconds <= 0) {
                            clearInterval(intervalId);
                            console.log("Token expired!");
                        }
                    }, 1000);
                }, delayUntilCountdown);
            }

            //Token already has <1 min left — show overlay only if this is not the first page load
            else if ((expireAt - Date.now()) > 0 && (expireAt - Date.now()) <= 60000) {
                const seconds = Math.floor((expireAt - Date.now()) / 1000);
                setSecondsLeft(seconds);
                setShowTimer(true);

                intervalId = setInterval(() => {
                    setSecondsLeft((prev) => {
                        const newVal = prev - 1;
                        if (newVal <= 0) {
                            clearInterval(intervalId);
                            console.warn("Token expired!");
                        }
                        return newVal;
                    });
                }, 1000);
            }

            return () => {
                clearTimeout(timeoutId);
                clearInterval(intervalId);
            };
        }
    }, [Jwttoken, tokenUpdatedAt]);

    useEffect(() => {
        if (showTimer) {
            // Disable background scroll
            document.body.style.overflow = 'hidden';
        } else {
            // Re-enable scroll
            document.body.style.overflow = 'auto';
        }

        // Cleanup on unmount
        return () => {
            document.body.style.overflow = 'hidden';
        };
    }, [showTimer]);

    return (
        <>
            <CssBaseline />
            {showTimer == true && (
                <SessionTimeoutAlert showTimer={showTimer} secondsLeft={secondsLeft} host={host} setShowTimer={setShowTimer} setTokenUpdatedAt={setTokenUpdatedAt} setToken={setToken} />
            )}
            <div className={classes.root}>
                <HeaderBar host={host} />
                <main className={classes.main}>{children}</main>
                <Copyright />
            </div>
        </>
    );
};

Layout.propTypes = {
  host: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired
};

export default Layout;